const flow = require('lodash/fp/flow');
const merge = require('lodash/merge');
const { format, subMonths } = require('date-fns');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');

const DATE_FORMAT = 'YYYY-MM-DD';

function apiFactory({
  baseUrl,
  requestHandler

}) {
  const headers = {
    Accept: 'application/json',
  };
  const reqOpts = { headers, method: 'GET' };

  const requestArray = flow(
    requestHandler,
    x => x.catch(e => {
      if (e.statusCode === 404) return [];
      throw e;
    })
  );

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getCashAccountbookings(bookingParam, metaData) {
      const parsedMetaData = parseRequestMetaData(metaData);
      const { pfId, fromDate, endDate ,positionObjId, balance, bookingDateType } = JSON.parse(Base64.decode(bookingParam));
      const url = getUrl('getRTCashAccDetails');
      const reqOpts = { headers, method: 'POST', json: true };
      const body = {
        userId: parsedMetaData.qs.userId,
        channel: parsedMetaData.channel,
        language: parsedMetaData.portfolio.language,
        pfId,
        positionObjId,
        fromDate: format(fromDate, DATE_FORMAT),
        toDate: format(endDate, DATE_FORMAT),
        balance,
        bookingDateType
      }

      return requestArray(merge(
        {},
        reqOpts,
        { url, body },
        parseRequestMetaData(metaData)
      ));
    },

    getRTCashAccList(inputParam, metaData) {       // Cash account list
      const url = getUrl('getRTCashAccList');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = JSON.parse(Base64.decode(inputParam));
      let body = {
        userId: parsedMetaData.qs.userId,
        relId: params.relId,
        relIdType: params.relIdType,
        language: parsedMetaData.portfolio.language,
        destinationCcy: params.destinationCcy,
        channel: parsedMetaData.channel,
        positionObjId: params.positionObjId,
        branchCode: parsedMetaData.portfolio.branchCode
      };
      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },
  };
}

module.exports = apiFactory;
